import axios from 'axios';

import { GoogleUrls } from '@/constants/baseUrls';
import { OwnHome } from '@/hooks/useSubmitLeadToZeus';
import { trackEvents } from '@/utils/analytics';
import getEnv from '@/utils/environment';

export interface BatteryLeadFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  zip: string;
}

export interface BatteryLeadProps {
  batteryData: BatteryLeadFormData;
  googleSheetUrls: GoogleUrls;
  propertyOwnership: OwnHome | undefined;
}

export const submitBatteryLeadToGoogle = async ({
  batteryData,
  googleSheetUrls,
  propertyOwnership,
}: BatteryLeadProps) => {
  trackEvents({
    event: 'Form Submitted',
    form_type: 'Battery Lead Form',
    ...(batteryData.email && {
      form_submit_email: batteryData.email,
    }),
    ...(propertyOwnership && {
      home_ownership: propertyOwnership,
    }),
    referral_status: 'not referred',
  });

  await axios.post(googleSheetUrls[getEnv()], null, {
    params: { ...batteryData },
  });
};
